module.exports = __webpack_public_path__ + "img/9.768bfd15.png";